import app from './Vue/app';
import { vMaska } from "maska/vue";

app.directive('maska', vMaska);

const checkEmail = async (e) => {
    e.target.classList.remove('error');
    let errors = e.target.parentNode.querySelectorAll('label.emailerror');
    errors.forEach(f => {
        f.parentNode.removeChild(f);
    })
    const response = await fetch('/brotherhood/checkemail/?email='+encodeURIComponent(e.target.value));
    const data = await response.json();
    if(!data.success){
        let error = document.createElement('label');
        error.classList.add('error');
        error.classList.add('emailerror');
        error.innerHTML = 'Sorry this email is already in use.';
        e.target.classList.add('error');
        e.target.after(error);
    }
}

app._component.methods.checkEmail = checkEmail;
